import React, { useState } from 'react';

function getPageNumbers(currentPage, totalPages) {
    if (totalPages <= 1) return [1];

    const delta = 1;
    const pages = [1];
    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
        pages.push(i);
    }
    if (currentPage - delta > 2) pages.splice(1, 0, '...');
    if (currentPage + delta < totalPages - 1) pages.push('...');
    if (totalPages > 1) pages.push(totalPages);

    return pages;
}

function Pagination({ currentPage, totalPages, onPageChange }) {
    const [jumpIndex, setJumpIndex] = useState(null);
    const [jumpValue, setJumpValue] = useState('');

    if (totalPages <= 1) return null;
    const pages = getPageNumbers(currentPage, totalPages);

    const submitJump = () => {
        const target = parseInt(jumpValue, 10);
        if (Number.isInteger(target)) {
            onPageChange(Math.min(Math.max(target, 1), totalPages));
        }
        setJumpIndex(null);
        setJumpValue('');
    };

    return (
        <nav className="flex items-center justify-center gap-6 mt-6 mb-10 text-sm uppercase">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage <= 1}
                className="text-gray-400 hover:text-green-500 disabled:opacity-40 disabled:hover:text-gray-400 disabled:cursor-not-allowed transition"
            >
                Prev
            </button>
            <ul className="flex items-center gap-4">
                {pages.map((p, idx) => (
                    p === '...' ? (
                        <li key={`ellipsis-${idx}`}>
                            {jumpIndex === idx ? (
                                <input
                                    type="number"
                                    min={1}
                                    max={totalPages}
                                    autoFocus
                                    value={jumpValue}
                                    onChange={(e) => setJumpValue(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') submitJump();
                                        if (e.key === 'Escape') { setJumpIndex(null); setJumpValue(''); }
                                    }}
                                    onBlur={submitJump}
                                    className="w-12 bg-transparent text-green-500 text-center border-b border-gray-600 focus:outline-none focus:border-green-500"
                                />
                            ) : (
                                <button
                                    onClick={() => { setJumpIndex(idx); setJumpValue(''); }}
                                    className="text-gray-600 hover:text-green-500 transition normal-case"
                                    title="Jump to page"
                                >
                                    …
                                </button>
                            )}
                        </li>
                    ) : (
                        <li key={p}>
                            <button
                                onClick={() => onPageChange(p)}
                                className={`transition ${
                                    p === currentPage
                                        ? 'text-green-500'
                                        : 'text-gray-400 hover:text-green-500'
                                }`}
                            >
                                {p}
                            </button>
                        </li>
                    )
                ))}
            </ul>
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage >= totalPages}
                className="text-gray-400 hover:text-green-500 disabled:opacity-40 disabled:hover:text-gray-400 disabled:cursor-not-allowed transition"
            >
                Next
            </button>
        </nav>
    );
}

export default Pagination;
